import React, { useCallback } from 'react';
import { RankedGamesDescriptionDialog } from '@colonist/clientforge';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
export const RankedGamesDescriptionDialogContainer = ({ open, onClose })=>{
    const onLearnMoreClick = useCallback(()=>navigateToPage('/faq#ranked', true, true), []);
    return /*#__PURE__*/ React.createElement(RankedGamesDescriptionDialog, {
        open: open,
        onClose: onClose,
        onLearnMoreClick: onLearnMoreClick
    });
};
